module.exports = __webpack_public_path__ + "img/caja-segura.cacce7e2.svg";